import React, { useEffect, useRef, useState } from 'react'
import useFooter from '@api/hooks/ambassdor/useFooter'
import { HEADER_TYPE, PROGRAM_TYPE } from '@utils/enum'
import { ImageDataSet, staticImages } from '@utils/ImpactSectionDataSet'
import { ImpactStoriesSectionWidget } from '@components/CscCompoents/impact-stories'
import { useNavigate } from 'react-router-dom'

const AmbassdorHeader = React.lazy(
  () => import('@components/Common/AmbassdorHeader')
)
const CSCHerosSection = React.lazy(
  () => import('@components/CscCompoents/CSCHerosSection/CSCHerosSection')
)

const ThreeStepsForCSC = React.lazy(
  () => import('@components/CscCompoents/StepsForCSC/StepsForCSC')
)

const ShapingFutureAccess = React.lazy(
  () =>
    import('@components/CscCompoents/ShapingFutureAccess/ShapingFutureAccess')
)
const HowCSCWork = React.lazy(
  () => import('@components/CscCompoents/HowCSCWork/HowCSCWork')
)

const Faq = React.lazy(() => import('@components/LandingPage/Faq/Faq'))

const MakeTheChange = React.lazy(
  () => import('@components/CscCompoents/MakeTheChange/MakeTheChange')
)

const Footer = React.lazy(() => import('@components/LandingPage/Footer/Footer'))

const CSCLandingPage = () => {
  const [footerData, setFooterData] = useState<any>()
  const [loginUrl, setLoginUrl] = useState<string>('')
  const navigate = useNavigate()
  const faqRef = useRef<HTMLDivElement>(null)
  const HowItWorksRef = useRef<HTMLDivElement>(null)
  const stepsRef = useRef<HTMLDivElement>(null)
  const presenceRef = useRef<HTMLDivElement>(null)
  const { data: dataFooter, isFetching: footerFetching } = useFooter()

  function randomNumber() {
    return Math.floor(10000000 + Math.random() * 90000000)
  }

  useEffect(() => {
    const currentStatus = JSON.parse(
      localStorage.getItem('currentStatus') || '{}'
    )
    const token =
      localStorage.getItem('token') || localStorage.getItem('TOKEN') || ''
    if (
      token &&
      currentStatus &&
      currentStatus?.programType === PROGRAM_TYPE.CSC_PROGRAM
    ) {
      navigate('/csc/dashboard')
    } else if (token && currentStatus) {
      navigate('/dashboard')
    }
    let url = `https://connect.csc.gov.in/account/authorize?response_type=code&client_id=3ca606aa-121b-4daf-fb84-66c1eb8dd6b4&redirect_uri=https://pw-ambassador-pre-prod.pw.live/csc/authorize&state=${randomNumber()}`
    setLoginUrl(url)
  }, [])

  useEffect(() => {
    if (!footerFetching) {
      setFooterData(dataFooter?.data?.data)
    }
  }, [footerFetching])

  return (
    <div className="bg-[#FAFAFF]">
      <AmbassdorHeader
        headerType={HEADER_TYPE.BEFORE_REGISTRATION}
        isPwlogoRequired={true}
        forCSC={true}
        headerTitle=" " //Import for csc logo css
        loginUrl={loginUrl}
        presenceRef={presenceRef}
        faqRef={faqRef}
        HowItWorksRef={HowItWorksRef}
        stepsRef={stepsRef}
      />
      <CSCHerosSection loginUrl={loginUrl} />
      <div ref={stepsRef} className="pt-6 relative">
        <div
          className="h-12 w-full rounded-t-3xl absolute top-[-45px]
            bg-[#FAFAFF]"
        ></div>

        <ThreeStepsForCSC />
      </div>
      <ImpactStoriesSectionWidget
        heading={'Educate Every Child in India'}
        images={ImageDataSet}
        staticImages={staticImages}
      />
      <div ref={presenceRef}>
        <ShapingFutureAccess />
      </div>
      <div ref={HowItWorksRef}>
        <HowCSCWork />
      </div>
      <div ref={faqRef} className="sm:pt-14">
        <Faq cameFrom="forCSC" />
      </div>
      <MakeTheChange loginUrl={loginUrl} />
      {footerData?.footer && (
        <Footer
          brand={footerData?.brand}
          showFreeLearning={false}
          appStores={footerData?.footer?.appStores}
          copyright={footerData?.footer?.copyright}
          menuSections={footerData?.footer?.menuSections}
          socials={footerData?.footer?.socials}
          subTitle={footerData?.footer?.subTitle}
        />
      )}
    </div>
  )
}
export default CSCLandingPage
